// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2CtyS","consentsList":"PatientConsents_consentsList__2d3Uc","consentsListEmpty":"PatientConsents_consentsListEmpty__1QK6M"};